import type { VerificationFormFieldsProps as Props } from "Components/UserAccount/Shared/VerificationForm/types";
import { LegalEntityVerificationFormFields } from "Components/UserAccount/Shared/VerificationForm/VerificationFormFields/LegalEntityVerificationFormFields";
import { NaturalPersonVerificationFormFields } from "Components/UserAccount/Shared/VerificationForm/VerificationFormFields/NaturalPersonVerificationFormFields";
import { SelfEmployedVerificationFormFields } from "Components/UserAccount/Shared/VerificationForm/VerificationFormFields/SelfEmployedVerificationFormFields";
import { PartyType } from "Infrastructure/Api/Api";
import type { FC } from "react";

export const PARTY_TYPE_TO_VERIFICATIONS_FORM_FIELDS: Record<
  PartyType,
  FC<Props>
> = {
  [PartyType.LegalEntity]: LegalEntityVerificationFormFields,
  [PartyType.SelfEmployed]: SelfEmployedVerificationFormFields,
  [PartyType.NaturalPerson]: NaturalPersonVerificationFormFields,
};
